export const instagramCommentFiltersInitialState = {
  contentTagFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'contentTagFilter',
    translateKey: 'filter:contentsTag',
    warning_label: 'content:tagApplyOnlyToPosts',
  },
  wordCloudFilter: {
    hasFilter: false,
    isOpen: false,
    selectedIds: [],
    componentName: 'wordCloudFilter',
    translateKey: 'filter:wordCloud',
  },
  seenStatusFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'both',
    componentName: 'seenStatusFilter',
    translateKey: 'filter:seenStatus',
  },
  sentimentFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValues: {
      positive: false,
      neutral: false,
      negative: false,
    },
    platform: 'instagramComment',
    componentName: 'sentimentFilter',
    translateKey: 'filter:contentsSentiment',
  },
  languageFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'all',
    componentName: 'languageFilter',
    translateKey: 'filter:language',
  },
  resourceCategoryFilter: {
    hasFilter: false,
    isOpen: false,
    platform: 'instagramComment',
    warning_label: 'content:categoryApplyOnlyToPosts',
    componentName: 'resourceCategoryFilter',
    translateKey: 'filter:resourceCategory',
    selectedValue: '',
    filterType: 'include',
    hasIncludeExclude: false,
  },
  resourcesFilter: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'include',
    selectedItems: {},
    hasIncludeExclude: false,
    platform: 'instagramComment',
    componentName: 'resourcesFilter',
    translateKey: 'filter:resourceSearch',
    title: 'filter:searchPostRelatedResource',
  },
  commentsOrRelatedPostComments: {
    hasFilter: false,
    isOpen: false,
    selectedValue: 'instagramCommentByPost',
    componentName: 'commentsOrRelatedPostComments',
  },
};
